import { AnonymousPageController } from "@modules/basic/page";
import { SortTypeDisplayValue } from "@modules/product/catalog-product/model/dto/SortTypeDisplayValue.enum";
import { Environment } from "../../../../environments/Environment";
import { Icatalog, IbreadcrumbCatalog, IcatalogsMap, ICatalogScope, IConstCatalog, ConstCatalog, Catalog, ICatalogPagePathMap, ICatalogPagePathMapItem } from "./index";
import { IAnonymousRestService } from "@modules/user/rest/anonymous-rest";
import { CatalogObjectTree } from "./catalog-object-tree";
import { envConfig } from "@env/env-config";
import { deserialize } from "typescript-json-serializer";
import is from "@core/comparators/is";

export class CatalogController extends AnonymousPageController {

    public static readonly $inject: Array<string> = ["$objectTree", "anonymousRestService", "$scope", "$window", "constCatalogs", "pageContext", "defaultCatalogPath", "defaultCatalogId"];

    // 所有类目
    private currentCatalog: Icatalog;
    private sortTypedisplayArr = SortTypeDisplayValue;
    private parentId: number;
    private pageLoading: boolean;
    // 文件地址前缀
    public fileRoot: string;
    // 产品类目面包屑导航数组（产品类目id）
    private breadcrumb: Array<IbreadcrumbCatalog>;
    // 产品类目映射数据
    private catalogsMap: IcatalogsMap;

    public customizePath: string;

    constructor(
        public $objectTree: CatalogObjectTree,
        public anonymousRestService: IAnonymousRestService,
        public $scope: ICatalogScope,
        public $window: angular.IWindowService,
        public constCatalogs: Array<ConstCatalog>,
        public pageContext: qpmn.main.IPageContext,
        public defaultCatalogPath: string,
        public defaultCatalogId: string
    ) {
        super($objectTree, anonymousRestService);
        this.currentCatalog = this.$objectTree.currentCatalog as Icatalog;
        this.fileRoot = `/${envConfig.apps.file}/file/`;

        // 开启骨架屏加载动画
        this.pageLoading = true;
        // constCatalogs:在模板(HTML)中创建,记录了类目CMS配置
        let catalogsViewValue: Array<Catalog> = [];
        for (let i = 0; i < this.constCatalogs.length; i++) {
            let catalogViewValue = deserialize(this.constCatalogs[i], Catalog);
            catalogsViewValue.push(catalogViewValue);
        }
        this.$objectTree.catalogs = catalogsViewValue;
        // 移动端布局处理:控制类目名称所在区域的显示隐藏
        this.$objectTree.productsHeaderFixed = false;
        //url参数（店铺id（个人中心--》店铺产品列表--》添加店铺产品））
        this.$objectTree.urlParameter = this.$window.location.search;

        this.$objectTree.defaultCatalog = this.defaultCatalogPath;
        // 设置网站默认类目Id
        this.$objectTree.defaultCatalogId = Number(this.defaultCatalogId);

        this.customizePath = pageContext.rootPath + "customize/";
        this.$objectTree.customizePath = this.customizePath;
    }


    public $onInit() {
        /************** TODO  ************ */


        // 创建产品类目配置数据Map映射
        this.catalogsMap = this.createCatalogsMap(this.$objectTree.catalogs);
        // TODO 本地map测试
        this.$objectTree.catalogPagePathMap = this.createCatalogPagePathMap(this.$objectTree.catalogs)
        this.$objectTree.catalogsMap = this.catalogsMap;
        // 设置默认产品类目路由地址
        this.$objectTree.defaultCatalogPagePath = this.createCatalogPagePath(this.$objectTree.defaultCatalogId);

        // 添加滚动事件监听（将页面操作框置顶）
        this.watchScroll();

        // 设置子类目展开处理
        this.setCatalogSpread();

        // 关闭页面初始化-骨架屏动画
        this.pageLoading = false;

        /************** TODO  ************ */
    }

    /**
     * @description 设置子类目展开处理
     */
    public setCatalogSpread() {
        this.$scope.$watch("catalogCtrl.$objectTree.currentCatalog.id", ((newCatalogId, oldCatalogId) => {
            let isopenOld: string, isopenNew: string;
            if (newCatalogId == oldCatalogId) {
                return;
            }
            let newCatalog = this.catalogsMap[newCatalogId as number];
            if (!angular.isUndefined(newCatalog) && newCatalog) {
                isopenNew = newCatalog.parentId ? `isopen_${newCatalog.parentId}` : `isopen_${newCatalog.id}`;
                this.$scope.catalogCtrl[isopenNew] = true;
                if (oldCatalogId) {
                    let oldCatalog = this.catalogsMap[oldCatalogId as number];
                    if (!angular.isUndefined(oldCatalog) && oldCatalog) {
                        isopenOld = oldCatalog?.parentId ? `isopen_${oldCatalog.parentId}` : `isopen_${oldCatalog.id}`;
                        // 修改父类目，打开关闭状态
                        if (isopenOld != isopenNew) {
                            this.$scope.catalogCtrl[isopenOld] = false;
                        }
                    }
                }
                // 更新面包屑导航
                this.breadcrumb = this.updateBreadcrumb(this.catalogsMap, newCatalog.catalogPath, this.customizePath);
            }
        }));
    }

    /**
     * @description 监听页面滚动事件，header和sort框固定到页面顶部
     * @description 返回顶部按钮显示与隐藏
     * */

    public watchScroll() {

        // 监听页面滚动事件
        this.$window.addEventListener("scroll", () => {
            let scrollTop = document.documentElement.scrollTop;
            // 未查询到指定元素，直接退出
            if (!document.getElementById("productsHeader")) {
                return;
            }
            // 获取“productsHeader”相距浏览器视窗顶部距离
            let productsHeaderTop: number = document.getElementById("productsHeader")?.offsetTop as number;
            // 获取购物车操作栏相对已视窗顶部的高度
            if (productsHeaderTop >= scrollTop) {
                if (!this.$objectTree.productsHeaderFixed) {
                    return;
                } else {
                    this.$scope.$apply(() => {
                        this.$objectTree.productsHeaderFixed = false;
                    });
                }
            } else {
                if (this.$objectTree.productsHeaderFixed) {
                    return;
                } else {
                    this.$scope.$apply(() => {
                        this.$objectTree.productsHeaderFixed = true;
                    })
                }
            }
        });
    }


    /**
     *@description 产品类目配置数据Map映射，便于对产品类目配置数据的查询处理
     *@param catalogs
     *@return catalogMap
     * */
    public createCatalogsMap(catalogs: Array<Icatalog>): IcatalogsMap {
        let catalogMap = {};
        catalogs.forEach(catalog => {
            catalogMap[String(catalog.id)] = catalog;
        });
        return catalogMap as IcatalogsMap;
    }

    /**
     * @description 
     * */
    public createCatalogPagePathMap(catalogs: Array<Icatalog>): Map<string, ICatalogPagePathMapItem> {
        let catalogPagePathMap = new Map<string, ICatalogPagePathMapItem>();
        catalogs.forEach(catalog => {
            let catalogPageNameArray: string[] = [], catalogPathIdArray: string[] = catalog.catalogPath.split(',');
            for (let i = 0; i < catalogPathIdArray.length; i++) {
                const currentCatalog = catalogs.find(item => {
                    return item.id === Number(catalogPathIdArray[i]);
                });
                if (!is.undefined(currentCatalog)) {
                    catalogPageNameArray.unshift(currentCatalog.pageName.replace('.html', ''));
                }
            }
            let catalogPageNamePath: string;
            if (catalogPageNameArray.length === 0) {
                throw new Error('CatalogController.createCatalogPagePathMap:The product category is invalid.');
            } else if (catalogPageNameArray.length === 1) {
                catalogPageNamePath = `${catalogPageNameArray[0]}/all`;
            } else {
                catalogPageNamePath = catalogPageNameArray.join('/');
            }
            const catalogViewValue: ICatalogPagePathMapItem = { ...catalog, catalogPagePath: catalogPageNamePath };
            catalogPagePathMap.set(catalogPageNamePath, catalogViewValue);
        });

        return catalogPagePathMap;

    }

    /**
     * @description  更新面包屑导航,根据当前产品类目的变换，动态更新面包屑导航数据
     * @description 面包屑导航配置数据（id：产品类目id；name：产品类目名称；pagePath:产品类目路由地址url）
     * @param catalogMap 产品类目映射
     * @param catalogPath 产品类目路径
     * @return breadcrumb
     * */
    public updateBreadcrumb(catalogMap: IcatalogsMap, catalogPath: string, customizePath: string): Array<IbreadcrumbCatalog> {
        let breadcrumb: Array<IbreadcrumbCatalog> = [];
        // 面包屑配置数据--路由地址(记录当前page路径地址前缀，用于子类目路由配置地址url)
        let pagePathStr: string;
        // 分割当前分类对应的产品类目id数据
        let catalogPathIds: Array<string> = catalogPath.split(',').reverse();
        // 遍历当前产品类目路径关联的产品类目id（当前产品类目id + 父类目产品id）
        catalogPathIds.forEach((catalogId, index) => {
            // 关联类目产品对应的导航项配置数据
            let relatedCatalog = catalogMap[catalogId];
            // 当前关联产品类目对应的路由配置地址
            let pagePath: string = '';
            // 创建面包屑产品类目配置数据--父类目（pageName/all），index==0时，当前产品类目为该产品类目的父节点
            if (index == 0) {
                pagePathStr = relatedCatalog.pageName;
                pagePath = relatedCatalog.pageName + '/all';
            }
            // 创建面包屑产品类目配置数据--子类目（parentPageName/childPageName），当前产品类目为该产品类目的非父节点
            if (index > 0) {
                pagePathStr = pagePathStr + "/" + relatedCatalog.pageName;
                pagePath = pagePathStr;
            }
            // 生成面包屑产品类目配置数据
            if (pagePath.length > 0) {
                let breadcrumbItem = {
                    name: relatedCatalog?.name as string,
                    id: relatedCatalog?.id as number,
                    pagePath: customizePath + pagePath
                }
                breadcrumb.push(breadcrumbItem);
            }
        });
        return breadcrumb;
    }
    /**
     * @description 根据产品类目Id和产品类目数组，创建产品类目路由地址
     * @param catalogId
     * */
    public createCatalogPagePath(catalogId: number): string {
        let catalogPageUrl: string, catalogPageList: string[] = [];
        let catalog = this.$objectTree.catalogs.find(catalogObj => {
            return catalogObj.id == this.$objectTree.defaultCatalogId;
        });
        while (!is.undefined(catalog)) {
            catalogPageList.unshift(catalog.pageName.replace('.html', ''));
            if (!is.undefined(catalog.parentId)) {
                catalog = this.$objectTree.catalogs.find(catalogObj => {
                    return catalogObj.id === catalog?.parentId as number;
                });
            } else {
                catalog = undefined;
            }
        }
        if (catalogPageList.length === 1) {
            // 产品主类目
            catalogPageUrl = `${catalogPageList[0]}/all`;
        } else {
            // 产品子类目
            catalogPageUrl = `${catalogPageList.join('/')}`;
        }
        return catalogPageUrl;
    }
}


